import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19028 13201"
    {...props}
  >
    <path
      d="M18782 6600 9094 114l4295 5751H137v1471h13252l-4295 5751z"
      style={{
        fill: "#2b2a29",
        stroke: "#1c1b17",
        strokeWidth: 274.192,
      }}
      className="fill stroke1"

    />
  </svg>
)
export default SvgComponent
